import React from 'react';
import Generate from '../../components/Generate';

const Home = () => (
  <div className="home">
    <Generate />
  </div>
);

export default Home;
